import React from "react";
import parser from "html-react-parser";

// Wrapper Component
const Wrapper = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};

const TextField = ({
  customErrorInputStyle = null,
  customErrorLabelStyle = null,
  customErrorMessageStyle = null,
  errorMessage = "",
  idField,
  isValid = true,
  isReadonly = false,
  label,
  type,
  inputClassName,
  labelClassName,
  inputWrapperClassName,
  labelWrapperClassName,
  name,
  onChangeHandler,
  onkeypress,
  placeholder,
  required,
  value,
  description,
  explanation,
  ...props
}) => {
  const getInputStyles = (isValid, customErrorInputStyle) => {
    if (!isValid && customErrorInputStyle) {
      return customErrorInputStyle;
    }
    return {
      border: isValid ? "1px solid #ccc" : "1px solid #960000",
      background: isValid ? "" : "#f9f0f0",
      width: "100%",
    };
  };

  const getLabelStyles = (isValid, customErrorLabelStyle) => {
    if (!isValid && customErrorLabelStyle) {
      return customErrorLabelStyle;
    }
    return {
      color: isValid ? "" : "#960000",
    };
  };

  return (
    <div className="tps-form-question">
      <Wrapper
        condition={!labelWrapperClassName}
        wrapper={(children) => <div className="tps-form-label">{children}</div>}
      >
        {!!label && label !== "" && (
          <label
            style={getLabelStyles(isValid, customErrorLabelStyle)}
            className={`${labelClassName ? labelClassName : ""} ${
              required
                ? "tps-field-required tps-to-validate"
                : "tps-not-required"
            }`}
            htmlFor={idField}
          >
            {parser(label)}
          </label>
        )}

        {!!explanation && explanation !== "" && (
          <div className="fas fa-info-circle tps-form-tip has-tip">
            <div
              className="tooltiptext"
              dangerouslySetInnerHTML={{ __html: explanation }}
            ></div>
          </div>
        )}
      </Wrapper>

      <Wrapper
        condition={!inputWrapperClassName}
        wrapper={(children) => <div className="tps-form-input">{children}</div>}
      >
        <input
          style={getInputStyles(isValid, customErrorInputStyle)}
          className={inputClassName ? inputClassName : ""}
          id={idField || name}
          name={name}
          type={type === "datetime" ? "datetime-local" : !!type ? type : "text"}
          placeholder={placeholder}
          required={required}
          autoComplete="off"
          value={value}
          onChange={(event) => onChangeHandler(event)}
          onKeyPress={onkeypress}
          readOnly={isReadonly}
          suppressHydrationWarning={true}
          {...props}
        />
        {!isValid && (
          <span
            className="EditingFormErrorLabel"
            style={customErrorMessageStyle}
          >
            {errorMessage}
          </span>
        )}
        {!!description && description !== "" && (
          <p
            className="tps-form-input-explaination"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        )}
      </Wrapper>
    </div>
  );
};

export default TextField;
